import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: center;
	justify-content: center;
	width: 120px;
	min-width: 120px;
	height: 120px;
	background: linear-gradient(
		360deg,
		rgba(255, 255, 255, 0.05) 0%,
		rgba(255, 255, 255, 0) 100%
	);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	img {
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		color: #ffffff;
	}
`;

export { StyledContainer };
